import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import TableSkeleton from 'modules/_shared/components/Tables/TableSkeleton';
import { TablePagination } from 'modules/_shared/Table/components/TablePagination';
import InputNumber from 'modules/_shared/components/InputNumber';

import { useDividendsDistributionModal } from '../context/DividendsDistributionModalContext';
import DividendsTable from './DividendsTable';

const DividendsDistributionModalDataView: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useDividendsDistributionModal();

  const showPagination = data.totalPartners && data.totalPartners > 10;

  return (
    <>
      <div className="form-group">
        <InputNumber
          id="dividend-amount"
          label={t('DividendsAmount')}
          value={data.totalAmount}
          onChange={actions.handleChangeTotalAmount}
          iconRight="ni ni-sign-euro"
          required
        />
      </div>

      <div className="form-group">
        <div className="custom-control custom-control-xs custom-checkbox">
          <input
            type="checkbox"
            id="checkbox-notifications"
            className="custom-control-input"
            checked={data.hasRetention}
            onChange={actions.handleChangeHasRetention}
          />
          <label
            className="custom-control-label"
            htmlFor="checkbox-notifications"
          >
            {t('DoYouWantToApplyRetention')}
          </label>
        </div>
      </div>

      {data.hasRetention && (
        <InputNumber
          id="retention-percentage"
          label={t('RetentionPercent')}
          value={data.retentionPercentage}
          onChange={actions.handleChangeRetentionPercentage}
          max={100}
          iconRight="ni ni-percent"
          required
        />
      )}

      {data.isDividendsLoading ? (
        <TableSkeleton
          rows={9}
          columns={3}
          showSubHeader={false}
          cardInner={false}
          height={446}
        />
      ) : (
        <DividendsTable />
      )}

      {showPagination && (
        <TablePagination
          totalRows={data.totalPartners || 0}
          onChangePage={actions.handleChangePage}
          onChangeRowsPerPage={actions.handleChangeRowsPerPage}
        />
      )}
    </>
  );
};

export default DividendsDistributionModalDataView;
